import script from "./AppSlippageForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppSlippageForm.vue?vue&type=script&setup=true&lang=ts"

import "./AppSlippageForm.vue?vue&type=style&index=0&id=2041808c&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2041808c"]])

export default __exports__